import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import NFOOrderBookReducer from "./nfoOrderBook";
export default combineReducers({
    reducersData: NFOOrderBookReducer,
    commonData: commonReducer,
});
